import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponsePaged } from '@core/interfaces/api.interface';
import { BaseService } from '@core/services/base.service';
import { mapPagedResponse } from '@core/utils/mapper-response-paged.util';
import {
  WorkOrderDetailMaintenanceAlerts,
  WorkOrderDetailMaintenanceAlertsFilters,
  WorkOrderDetailMaintenanceAlertsForm,
} from '@features/advanced-maintenance/interfaces/work-orders.interface';

@Injectable({ providedIn: 'root' })
export class MaintenanceSchedulesService extends BaseService {
  constructor() {
    super('MaintenanceSchedule');
  }

  getAll(
    params: WorkOrderDetailMaintenanceAlertsFilters,
  ): Observable<ApiResponsePaged<WorkOrderDetailMaintenanceAlerts>> {
    return this.GET<HttpResponse<WorkOrderDetailMaintenanceAlerts[]>>('', params, {
      observe: 'response',
    }).pipe(mapPagedResponse<WorkOrderDetailMaintenanceAlerts>());
  }

  create(
    payload: WorkOrderDetailMaintenanceAlertsForm,
  ): Observable<WorkOrderDetailMaintenanceAlerts> {
    return this.POST<WorkOrderDetailMaintenanceAlerts>('', payload);
  }

  update(
    id: string,
    payload: WorkOrderDetailMaintenanceAlertsForm,
  ): Observable<WorkOrderDetailMaintenanceAlerts> {
    return this.PUT<WorkOrderDetailMaintenanceAlerts>(id, payload);
  }

  delete(id: string): Observable<void> {
    return this.DELETE<void>(id);
  }

  export(params: WorkOrderDetailMaintenanceAlertsFilters): Observable<HttpResponse<Blob>> {
    return this.GET<HttpResponse<Blob>>('get-excel', params, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
